import _toConsumableArray from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  style: {
    "margin-left": "6px"
  }
};
import { FORM_ITEM } from '../form/enums';
import { ElForm } from 'element-plus';
import 'element-plus/es/components/form/style/css'

import XSelect from '../x-select/XSelect.vue';
import { createIconNode } from '@/component-create/utils/common';
import { EVENT_NAME } from '@/component-create/SearchForm';
import { log } from '@/component-create/utils/log';

import { toRefs, ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XSearchForm',
  props: {
    items: {},
    elFormProps: {},
    getInstance: {
      type: Function
    },
    handler: {}
  },
  emits: ['search', 'reset'],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var prop = __props;
    var emit = __emit;
    var _toRefs = toRefs(prop),
      items = _toRefs.items,
      elFormProps = _toRefs.elFormProps;
    //表单数据
    var formData = ref({});
    // 用户定义的重置事件
    var customResetHandler = ref();
    // 用户定义的搜索事件
    var customSearchHandler = ref();
    // 表单项宽度
    var colSpan = ref(6);
    // 是否展开
    var expansion = ref(false);
    // 是否处于小窗口
    var smallCount = ref(3);
    var elFormRef = ref();
    var instance = new Proxy({}, {});
    var hideKey = ref([]);
    var defaultValue = ref({});
    var formRef = ref();
    /**
     * 暴露属性方法
     */
    if (prop.getInstance) {
      prop.getInstance(instance);
    }
    instance.setResetEventHandler = setResetEventHandler;
    instance.setSearchEventHandler = setSearchEventHandler;
    instance.setFormData = setFormData;
    instance.getFormData = getFormData;
    instance.getFormDataNotValidate = getFormDataNotValidate;
    instance.elFormInstance = elFormRef.value;
    instance.updateFormData = updateFormData;
    instance.hideFormItemByKey = hideFormItemByKey;
    instance.showFormItemByKey = showFormItemByKey;
    instance.reset = reset;
    setCol();
    onMounted(function () {
      defaultValue.value = _objectSpread({}, formData.value);
    });
    window.addEventListener('resize', setCol);
    function setCol() {
      if (document.body.clientWidth <= 1500) {
        smallCount.value = 2;
        colSpan.value = 8;
      } else {
        smallCount.value = 3;
        colSpan.value = 6;
      }
    }
    /**
     * 处理展开收起
     */
    function handleExpansion() {
      expansion.value = !expansion.value;
    }
    /**
     * 构造虚拟下拉框选项
     * @param options 传入的选项
     * @param labelKey 标签key
     * @param valueKey 值字段
     */
    function getVirtualizedSelectOptions(options, labelKey, valueKey) {
      return options.map(function (item) {
        return {
          label: item[labelKey],
          value: item[valueKey]
        };
      });
    }
    /**
     * 获取表单数据
     */
    function getFormData() {
      return new Promise(function (resolve, reject) {
        if (!elFormRef.value) {
          log('XSearchForm', '表单实例未找到', 'error');
          reject('表单实例未找到');
        } else {
          elFormRef.value.validate(function (valid) {
            if (valid) {
              resolve(formData.value);
            } else {
              reject('校验未通过');
            }
          });
        }
      });
    }
    /**
     * 获取表单数据，不校验
     */
    function getFormDataNotValidate() {
      return formData.value;
    }
    /**
     * 搜索事件
     */
    function search() {
      var _formRef$value;
      (_formRef$value = formRef.value) === null || _formRef$value === void 0 || _formRef$value.validate(function (valid) {
        if (valid) {
          if (prop.handler && prop.handler[EVENT_NAME.SEARCH]) {
            prop.handler[EVENT_NAME.SEARCH](formData.value);
          } else {
            emit('search', formData.value);
          }
        }
      });
    }
    /**
     * 更新表单数据
     */
    function updateFormData(data) {
      formData.value = _objectSpread(_objectSpread({}, formData.value), data);
    }
    /**
     * 重置事件
     */
    function clear() {
      formData.value = {};
      if (prop.handler && prop.handler[EVENT_NAME.RESET]) {
        prop.handler[EVENT_NAME.RESET]();
      } else {
        emit('reset');
      }
    }
    /**
     * 绘制用户定义的VNode方法
     * @param fn 绘制方法
     */
    function renderCustomItem(fn) {
      return fn();
    }
    /**
     * 设置搜索事件处理函数
     * @param handler 处理函数
     */
    function setSearchEventHandler(handler) {
      customSearchHandler.value = handler;
    }
    /**
     * 设置重置事件处理函数
     * @param handler 处理函数
     */
    function setResetEventHandler(handler) {
      customResetHandler.value = handler;
    }
    /**
     * 设置表单值
     * @param data 值
     */
    function setFormData(data) {
      formData.value = data;
    }
    /**
     * 重置表单
     */
    function reset() {
      formData.value = _objectSpread({}, defaultValue.value);
    }
    /**
     * 隐藏表单项
     */
    function hideFormItemByKey(key) {
      if (typeof key === 'string') {
        hideKey.value.push(key);
        if (formData.value[key] !== undefined) {
          formData.value[key] = undefined;
        }
      } else {
        var _hideKey$value;
        (_hideKey$value = hideKey.value).push.apply(_hideKey$value, _toConsumableArray(key));
        key.forEach(function (k) {
          if (formData.value[k] !== undefined) {
            formData.value[k] = undefined;
          }
        });
      }
    }
    /**
     * 显示表单项
     */
    function showFormItemByKey(key) {
      if (typeof key === 'string') {
        var i = hideKey.value.findIndex(function (hkey) {
          return hkey === key;
        });
        if (i > -1) {
          hideKey.value.splice(i, 1);
        }
      } else {
        key.forEach(function (k) {
          var i = hideKey.value.findIndex(function (hkey) {
            return hkey === k;
          });
          if (i > -1) {
            hideKey.value.splice(i, 1);
          }
        });
      }
      hideKey.value = _toConsumableArray(hideKey.value);
    }
    __expose({
      setFormData: setFormData,
      getFormData: getFormData,
      getFormDataNotValidate: getFormDataNotValidate
    });
    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_option = _resolveComponent("el-option");
      var _component_el_select = _resolveComponent("el-select");
      var _component_el_autocomplete = _resolveComponent("el-autocomplete");
      var _component_el_cascader = _resolveComponent("el-cascader");
      var _component_el_checkbox = _resolveComponent("el-checkbox");
      var _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      var _component_el_color_picker = _resolveComponent("el-color-picker");
      var _component_el_date_picker = _resolveComponent("el-date-picker");
      var _component_el_input_number = _resolveComponent("el-input-number");
      var _component_el_radio = _resolveComponent("el-radio");
      var _component_el_radio_group = _resolveComponent("el-radio-group");
      var _component_el_rate = _resolveComponent("el-rate");
      var _component_el_select_v2 = _resolveComponent("el-select-v2");
      var _component_el_slider = _resolveComponent("el-slider");
      var _component_el_switch = _resolveComponent("el-switch");
      var _component_el_time_picker = _resolveComponent("el-time-picker");
      var _component_el_time_select = _resolveComponent("el-time-select");
      var _component_el_transfer = _resolveComponent("el-transfer");
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_col = _resolveComponent("el-col");
      var _component_el_button = _resolveComponent("el-button");
      var _component_IEpArrowDown = _resolveComponent("IEpArrowDown");
      var _component_IEpArrowUp = _resolveComponent("IEpArrowUp");
      var _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createBlock(_unref(ElForm), _mergeProps(_unref(elFormProps), {
        model: _unref(formData),
        ref_key: "formRef",
        ref: formRef
      }), {
        default: _withCtx(function () {
          return [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), function (item, index) {
                return _openBlock(), _createBlock(_Transition, {
                  key: index
                }, {
                  default: _withCtx(function () {
                    return [_withDirectives(_createVNode(_component_el_col, {
                      span: _unref(colSpan)
                    }, {
                      default: _withCtx(function () {
                        return [_createVNode(_component_el_form_item, {
                          label: item.label,
                          prop: item.key
                        }, {
                          default: _withCtx(function () {
                            return [item.el === _unref(FORM_ITEM).INPUT ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                              key: 0,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, _objectSpread({
                              placeholder: '请输入' + item.label
                            }, item.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).EL_SELECT ? (_openBlock(), _createBlock(_component_el_select, _mergeProps({
                              key: 1,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, _objectSpread({
                              placeholder: '请选择' + item.label
                            }, item.props || {})), {
                              default: _withCtx(function () {
                                return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options || [], function (option) {
                                  return _openBlock(), _createBlock(_component_el_option, {
                                    key: option[item.labelKey || 'value'],
                                    label: option[item.labelKey || 'label'],
                                    value: option[item.valueKey || 'value']
                                  }, null, 8, ["label", "value"]);
                                }), 128))];
                              }),
                              _: 2
                            }, 1040, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).SELECT ? (_openBlock(), _createBlock(XSelect, _mergeProps({
                              key: 2,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, _objectSpread({
                              elProps: {
                                placeholder: '请选择' + item.label
                              }
                            }, item.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).AUTOCOMPLETE ? (_openBlock(), _createBlock(_component_el_autocomplete, _mergeProps({
                              key: 3,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, _objectSpread({
                              placeholder: '请输入' + item.label
                            }, item.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).CASCADER ? (_openBlock(), _createBlock(_component_el_cascader, _mergeProps({
                              key: 4,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, _objectSpread({
                              placeholder: '请选择' + item.label
                            }, item.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).CHECKBOX ? (_openBlock(), _createBlock(_component_el_checkbox_group, _mergeProps({
                              key: 5,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, item.props || {}), {
                              default: _withCtx(function () {
                                return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options || [], function (option) {
                                  return _openBlock(), _createBlock(_component_el_checkbox, {
                                    key: option[item.labelKey || 'value'],
                                    label: option[item.valueKey || 'value']
                                  }, {
                                    default: _withCtx(function () {
                                      return [_createTextVNode(_toDisplayString(option[item.labelKey || 'label']), 1)];
                                    }),
                                    _: 2
                                  }, 1032, ["label"]);
                                }), 128))];
                              }),
                              _: 2
                            }, 1040, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).COLOR_PICKER ? (_openBlock(), _createBlock(_component_el_color_picker, _mergeProps({
                              key: 6,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, item.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).DATE_PICKER_CUSTOM ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                              key: 7,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, _objectSpread({
                              placeholder: '请选择' + item.label
                            }, item.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).DATE_PICKER ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                              key: 8,
                              type: "date",
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, _objectSpread({
                              placeholder: '请选择' + item.label
                            }, item.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).DATETIME_PICKER ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                              key: 9,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, _objectSpread({
                              placeholder: '请选择' + item.label
                            }, item.props || {}), {
                              type: "datetime"
                            }), null, 16, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).INPUT_NUMBER ? (_openBlock(), _createBlock(_component_el_input_number, _mergeProps({
                              key: 10,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, _objectSpread({
                              placeholder: '请输入' + item.label
                            }, item.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).RADIO ? (_openBlock(), _createBlock(_component_el_radio_group, _mergeProps({
                              key: 11,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, item.props || {}), {
                              default: _withCtx(function () {
                                return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options || [], function (option) {
                                  return _openBlock(), _createBlock(_component_el_radio, {
                                    key: option[item.labelKey || 'value'],
                                    label: option[item.valueKey || 'value']
                                  }, {
                                    default: _withCtx(function () {
                                      return [_createTextVNode(_toDisplayString(option[item.labelKey || 'label']), 1)];
                                    }),
                                    _: 2
                                  }, 1032, ["label"]);
                                }), 128))];
                              }),
                              _: 2
                            }, 1040, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).RATE ? (_openBlock(), _createBlock(_component_el_rate, _mergeProps({
                              key: 12,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, item.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).VIRTUALIZED_SELECT ? (_openBlock(), _createBlock(_component_el_select_v2, _mergeProps({
                              key: 13,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              options: getVirtualizedSelectOptions(item.options || [], item.labelKey || 'label', item.valueKey || 'value'),
                              ref_for: true
                            }, _objectSpread({
                              placeholder: '请选择' + item.label
                            }, item.props || {})), null, 16, ["modelValue", "onUpdate:modelValue", "options"])) : item.el === _unref(FORM_ITEM).SLIDER ? (_openBlock(), _createBlock(_component_el_slider, _mergeProps({
                              key: 14,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, item.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).SWITCH ? (_openBlock(), _createBlock(_component_el_switch, _mergeProps({
                              key: 15,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, item.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).TIME_PICKER ? (_openBlock(), _createBlock(_component_el_time_picker, _mergeProps({
                              key: 16,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, _objectSpread({
                              placeholder: '请选择' + item.label
                            }, item.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).TIME_SELECT ? (_openBlock(), _createBlock(_component_el_time_select, _mergeProps({
                              key: 17,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, _objectSpread({
                              placeholder: '请选择' + item.label
                            }, item.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : item.el === _unref(FORM_ITEM).TRANSFER ? (_openBlock(), _createBlock(_component_el_transfer, _mergeProps({
                              key: 18,
                              modelValue: _unref(formData)[item.key],
                              "onUpdate:modelValue": function onUpdateModelValue($event) {
                                return _unref(formData)[item.key] = $event;
                              },
                              ref_for: true
                            }, item.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : typeof item.el === 'function' ? (_openBlock(), _createBlock(_resolveDynamicComponent(renderCustomItem(item.el)), _mergeProps({
                              key: 19,
                              ref_for: true
                            }, item.props || {}), null, 16)) : (_openBlock(), _createBlock(_resolveDynamicComponent(item.el), _mergeProps({
                              key: 20,
                              ref_for: true
                            }, item.props || {}), null, 16))];
                          }),
                          _: 2
                        }, 1032, ["label", "prop"])];
                      }),
                      _: 2
                    }, 1032, ["span"]), [[_vShow, index < _unref(smallCount) || _unref(expansion)]])];
                  }),
                  _: 2
                }, 1024);
              }), 128)), _createVNode(_component_el_col, {
                style: {
                  "min-width": "260px"
                },
                span: _unref(colSpan),
                class: "action_col"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_form_item, {
                    class: "action"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_button, {
                        type: "primary",
                        icon: _unref(createIconNode)('Search'),
                        onClick: search
                      }, {
                        default: _withCtx(function () {
                          return _cache[0] || (_cache[0] = [_createTextVNode("查询")]);
                        }),
                        _: 1
                      }, 8, ["icon"]), _createVNode(_component_el_button, {
                        icon: _unref(createIconNode)('Refresh'),
                        onClick: clear
                      }, {
                        default: _withCtx(function () {
                          return _cache[1] || (_cache[1] = [_createTextVNode("重置")]);
                        }),
                        _: 1
                      }, 8, ["icon"]), _unref(items).length > 24 / _unref(colSpan) - 1 ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "expansion",
                        onClick: handleExpansion
                      }, [!_unref(expansion) ? (_openBlock(), _createBlock(_component_IEpArrowDown, {
                        key: 0
                      })) : (_openBlock(), _createBlock(_component_IEpArrowUp, {
                        key: 1
                      })), _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(expansion) ? '收起' : '展开'), 1)])) : _createCommentVNode("", true)];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }, 8, ["span"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 16, ["model"]);
    };
  }
});